<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<p class="C333" id="page_xiii">
<strong>CUE-TITLES</strong>
</p>
<p class="C362">
<strong>A. Manuscript locations</strong>
</p>
<div class="table">
<table class="C393" style="width:100%;">
<tr class="T317_FirstRow">
<td class="C424" style="vertical-align:top;">ColU</td>
<td class="C425" style="vertical-align:top;">Columbia University</td>
</tr>
<tr class="T317_Row">
<td class="C403" style="vertical-align:top;">UIll</td>
<td class="C401" style="vertical-align:top;">University of Illinois at Urbana–Champaign</td>
</tr>
<tr class="T317_Row">
<td class="C403" style="vertical-align:top;">UT</td>
<td class="C401" style="vertical-align:top;">University of Texas at Austin</td>
</tr>
<tr class="T317_LastRow">
<td class="C403" style="vertical-align:top;">YU</td>
<td class="C401" style="vertical-align:top;">Yale University</td>
</tr>
</table>
</div>
<p class="C362">
<strong>B. Printed works</strong>
</p>
<p class="C345">(The place of publication, here and throughout, is London unless otherwise stated.)</p>
<div class="table">
<table class="C393" style="width:100%;">
<tr class="T317_FirstRow">
<td class="C426" style="vertical-align:top;">
<em>Aaron's Rod</em>
</td>
<td class="C428" style="vertical-align:top;">
<p class="jus">D. H. Lawrence. <em>Aaron's Rod</em>. Ed. Mara Kalnins. Cambridge: Cambridge University Press, 1988.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Complete Poems</em>
</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">Vivian de Sola Pinto and Warren Roberts, eds. <em>The Complete Poems of D. H. Lawrence</em>. 2 volumes. Heinemann, 1964.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">Lacy, <em>Seltzer</em>
</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">Gerald M. Lacy, ed. <em>D. H. Lawrence: Letters to Thomas and Adele Seltzer</em>. Santa Barbara: Black Sparrow Press, 1976.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Letters</em>, i.</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">James T. Boulton, ed. <em>The Letters of D. H. Lawrence</em>. Volume I. Cambridge: Cambridge University Press, 1979.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Letters</em>, ii.</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">George J. Zytaruk and James T. Boulton, eds. <em>The Letters of D. H. Lawrence</em>. Volume II. Cambridge: Cambridge University Press, 1981.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Letters</em>, iii.</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">James T. Boulton and Andrew Robertson, eds. <em>The Letters of D. H. Lawrence</em>. Volume III. Cambridge: Cambridge University Press, 1984.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Letters</em>, iv.</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">Warren Roberts, James T. Boulton and Elizabeth Mansfield, eds. <em>The Letters of D. H. Lawrence</em>. Volume IV. Cambridge: Cambridge University Press, 1987.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>
<a id="page_xiv">
</a>Letters</em>, v.</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">James T. Boulton and Lindeth Vasey, eds. <em>The Letters of D. H. Lawrence</em>. Volume V. Cambridge: Cambridge University Press, 1989.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Movements</em>
</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">D. H. Lawrence. <em>Movements in European History</em>. Ed. Philip Crumpton. Cambridge: Cambridge University Press, 1989.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Phoenix</em>
</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">Edward D. McDonald, ed. <em>Phoenix: The Posthumous Papers of D. H. Lawrence</em>. New York: Viking, 1936.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">
<em>Phoenix II</em>
</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">Warren Roberts and Harry T. Moore, eds. <em>Phoenix II: Uncollected, Unpublished and Other Prose Works by D. H. Lawrence</em>. Heinemann, 1968.</p>
</td>
</tr>
<tr class="T318_Row">
<td class="C403" style="vertical-align:top;">Roberts</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">Warren Roberts. <em>A Bibliography of D. H. Lawrence</em>. 2nd edn. Cambridge: Cambridge University Press, 1982.</p>
</td>
</tr>
<tr class="T318_LastRow">
<td class="C403" style="vertical-align:top;">Tedlock, <em>Lawrence MSS</em>
</td>
<td class="C401" style="vertical-align:top;">
<p class="jus">E. W. Tedlock. <em>The Frieda Lawrence Collection of D. H. Lawrence Manuscripts: A Descriptive Bibliography</em>. Albuquerque: University of New Mexico Press, 1948.</p>
</td>
</tr>
</table>
</div>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Cue_titles.vue?51c7a8cf